<template>
<div class="padding">
  <h4 class="text-center">
    Template Testing
  </h4>
    <el-tabs v-model="type">
      <el-tab-pane label="payment" name="payment"></el-tab-pane>
      <el-tab-pane label="registration" name="registration"></el-tab-pane>
    </el-tabs>
  <el-row :gutter="20">
    <el-col  :span=6>
      <el-input placeholder="Email" v-model="email"></el-input>
      <small class="text-danger" v-if="error">{{this.error}}</small>
    </el-col>
  </el-row>
  <el-row :gutter=20>
    <el-col>
      <el-button type="primary" @click="getTemplate">Get Template</el-button>
    </el-col>
  </el-row>
</div>
</template>

<script>
import {Button, Input, Row, Col, Tabs, TabPane} from 'element-ui'
import axios from 'axios'
export default {
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  data () {
    return {
      email: '',
      type: 'payment',
      error: ''
    }
  },
  methods: {
    getTemplate () {
      let emailRegEx = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      if (emailRegEx.test(this.email)) {
        this.error = ''
        axios({
          url: process.env.SERVER_URI + '/getEmailTemplate',
          method: 'post',
          data: {email: this.email, type: this.type}
        })
        .then((response) => {
          this.versionDetails = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        this.error = 'The email is required/invalid'
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

.padding {
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/GeneralViews/TemplateTesting.vue